var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluedownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baseline-arrow_downward-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11408",
    "data-name": "Path 11408",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down",
    transform: "translate(5.869 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M6.9,10.069,2.6,5.726,3.714,4.6,6.9,7.817,10.079,4.6l1.114,1.126Z",
    transform: "translate(-2.6 -4.6)",
    fill: "#0092ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluedownarrow);
export default __webpack_public_path__ + "static/media/bluedownarrow.36fad21ccf3f3f5b76fc6772d511389d.svg";
export { ForwardRef as ReactComponent };